export default __webpack_public_path__ + "static/media/phonon_coffee_3.eb32ac93.jpg";